import axios from 'axios';

export const UPDATE_STUDENT_REQUEST_START = 'UPDATE_STUDENT_REQUEST_START';
export const UPDATE_STUDENT_REQUEST_SUCCESS = 'UPDATE_STUDENT_REQUEST_SUCCESS';
export const UPDATE_STUDENT_REQUEST_FAILURE = 'UPDATE_STUDENT_REQUEST_FAILURE';

export const updateStudentRequest = (requestId, studentId, teacherCourseId, onSuccess) => async (dispatch) => {
  dispatch({ type: UPDATE_STUDENT_REQUEST_START });

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/admin/confirm`, null, {
      params: { requestId, studentId }
    });

    dispatch({
      type: UPDATE_STUDENT_REQUEST_SUCCESS,
      payload: response.data,
    });

    // ✅ Re-fetch updated requests
    if (typeof onSuccess === 'function') onSuccess();

  } catch (error) {
    dispatch({
      type: UPDATE_STUDENT_REQUEST_FAILURE,
      payload: error.response?.data || 'Failed to update student request',
    });
  }
};
